export const missionsRoutes = {
    root: 'missions',
};
